import React from "react";
import PropTypes from "prop-types";
import styles from "./SparaLoader.module.scss";

const SparaLoader = ({ text }) => {
    return (
        <div className={styles.loaderContainer}>
            <div className={styles.loader} />
            {text && <div className={styles.text}>{text}</div>}
        </div>
    );
};

SparaLoader.propTypes = {
    text: PropTypes.string,
};

export default SparaLoader;
